import styled from 'styled-components';

export const StyledLinkAccordionBody = styled.div``;
